import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelL, LabelM } from '@sorare/core/src/atoms/typography';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import type { StarPackContents_cardPack } from './__generated__/index.graphql';

const Root = styled(Vertical)`
  padding-top: var(--double-unit);
`;

export const StarPackContents = () => {
  const { sport } = useSportContext();
  return (
    <Root gap={2}>
      <LabelL bold>
        <FormattedMessage
          id="StarPackContents.title"
          defaultMessage="What's a Star Pack?"
        />
      </LabelL>
      <Vertical gap={2} as={LabelM} color="var(--c-nd-700)">
        <FormattedMessage
          id="StarPackContents.description4"
          defaultMessage="<p>Each league has a featured Star Player that rotates every Game Week.{br}Open 10 Basic or Elite Packs from that league to unlock your Star Pack.</p><p>You have a 20% chance to get the Star Player in the Star Pack, and 80% for a {cardTier} card.{br}Your odds increase every time you miss, up to 100%.</p><p> Your progress carries over between Star Players.</p>"
          values={{
            br: <br />,
            p: chunks => <p>{chunks}</p>,
            cardTier: sport === Sport.NBA ? 'Roster Player' : 'Key Player',
          }}
        />
      </Vertical>
    </Root>
  );
};

StarPackContents.fragments = {
  cardPack: gql`
    fragment StarPackContents_cardPack on CardPack {
      slug
      slots {
        rankOdds {
          dropRank
          commonPlayer {
            id
          }
        }
      }
    }
  ` as TypedDocumentNode<StarPackContents_cardPack>,
};
